import { type ReactNode } from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import MainTheme from 'theme/MainTheme';
import { IntlProvider } from 'react-intl';
import fr from 'locales/fr';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from 'pages/ErrorPage';

type ProvidersProps = {
  children: ReactNode;
};

const Providers = ({ children }: ProvidersProps): JSX.Element => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={MainTheme}>
      <IntlProvider
        defaultLocale={fr.locale}
        defaultRichTextElements={{
          br: () => <br />,
        }}
        locale={fr.locale}
        messages={fr.messages}
      >
        <ErrorBoundary FallbackComponent={ErrorPage}>
          {children}
        </ErrorBoundary>
      </IntlProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);

export default Providers;
